import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import jwtUtil from '@/utils/jwtUtil'
Vue.use(VueRouter)

const DEALER = ['dealer']

const routes = [
    {
        path: '/',
        name: 'Home',
        meta: { roles: DEALER, title: 'Dashboard' },
        component: () => import('@/routes/HomeRoute')
    },
    {
        path: '/login',
        name: 'Login',
        meta: { public: true },
        component: () => import('@/routes/LoginRoute')
    },
    {
        path: '/members',
        name: 'Members',
        meta: { roles: DEALER, title: 'Members' },
        component: () => import('@/routes/MemberRoute')
    },
    {
        path: '/offers',
        name: 'Offers',
        meta: { title: 'Offers' },
        component: () => import('@/routes/OfferRoute')
    },
    {
        path: '/partners',
        name: 'Partners',
        meta: { roles: DEALER, title: 'Partners' },
        component: () => import('@/routes/PartnerRoute')
    },
    {
        path: '/dealers',
        name: 'Dealers',
        meta: { title: 'Dealers' },
        component: () => import('@/routes/DealerRoute')
    },
    {
        path: '/teams',
        name: 'Teams',
        meta: { roles: DEALER, title: 'Teams' },
        component: () => import('@/routes/TeamRoute')
    },
    {
        path: '/users',
        name: 'Users',
        meta: { title: 'Users' },
        component: () => import('@/routes/UserRoute')
    },
    {
        path: '/transactions',
        name: 'Transactions',
        meta: { roles: DEALER, title: 'Transactions' },
        component: () => import('@/routes/TransactionRoute')
    },
    {
        path: '/image-gallery',
        name: 'Image Gallery',
        meta: { title: 'Image Gallery' },
        component: () => import('@/routes/ImageGalleryRoute')
    },
    {
        path: '/articles',
        name: 'Articles',
        meta: { title: 'Articles' },
        component: () => import('@/routes/ArticleRoute')
    },
    {
        path: '/cards',
        name: 'Cards',
        meta: { title: 'Cards' },
        component: () => import('@/routes/CardRoute')
    },
    {
        path: '/vouchers',
        name: 'Vouchers',
        meta: { title: 'Vouchers' },
        component: () => import('@/routes/VoucherRoute')
    },
    {
        path: '/articles/:articleId/:mode',
        name: 'Article Form',
        meta: { title: 'Articles' },
        component: () => import('@/forms/ArticleForm')
    },
    {
        path: '/members/:memberId/:mode',
        name: 'Member Form',
        meta: { roles: DEALER, title: 'Members' },
        component: () => import('@/forms/MemberForm')
    },
    {
        path: '/dealers/:dealerId/:mode',
        name: 'Dealer Form',
        meta: { title: 'Dealers' },
        component: () => import('@/forms/DealerForm')
    },
    {
        path: '/partners/:partnerId/:mode',
        name: 'Partner Form',
        meta: { roles: DEALER, title: 'Partners' },
        component: () => import('@/forms/PartnerForm')
    },
    {
        path: '/teams/:teamId/:mode',
        name: 'Team Form',
        meta: { roles: DEALER, title: 'Teams' },
        component: () => import('@/forms/TeamForm')
    },
    {
        path: '/users/:userId/:mode',
        name: 'User Form',
        meta: { title: 'Users' },
        component: () => import('@/forms/UserForm')
    },
    {
        path: '/transactions/:transactionId/:mode',
        name: 'Transaction Form',
        meta: { roles: DEALER, title: 'Transactions' },
        component: () => import('@/forms/TransactionForm')
    },
    {
        path: '/cards/:cardId/:mode',
        name: 'Card Form',
        meta: { title: 'Cards' },
        component: () => import('@/forms/CardForm')
    },
    {
        path: '/vouchers/:voucherId/:mode',
        name: 'Voucher Form',
        meta: { title: 'Vouchers' },
        component: () => import('@/forms/VoucherForm')
    },
    {
        path: '/offers/:offerId/:mode',
        name: 'Offer Form',
        meta: { title: 'Offers' },
        component: () => import('@/forms/OfferForm')
    },
    {
        path: '/articles/:mode',
        name: 'Create Article Form',
        meta: { title: 'Articles' },
        component: () => import('@/forms/ArticleForm')
    },
    {
        path: '/members/:mode',
        name: 'Create Member Form',
        meta: { roles: DEALER, title: 'Members' },
        component: () => import('@/forms/MemberForm')
    },
    {
        path: '/dealers/:mode',
        name: 'Create Dealer Form',
        meta: { title: 'Dealers' },
        component: () => import('@/forms/DealerForm')
    },
    {
        path: '/cards/:mode',
        name: 'Create Card Form',
        meta: { title: 'Cards' },
        component: () => import('@/forms/CardForm')
    },
    {
        path: '/vouchers/:mode',
        name: 'Create Voucher Form',
        meta: { title: 'Vouchers' },
        component: () => import('@/forms/VoucherForm')
    },
    {
        path: '/offers/:mode',
        name: 'Create Offer Form',
        meta: { title: 'Offers' },
        component: () => import('@/forms/OfferForm')
    },
    {
        path: '/partners/:mode',
        name: 'Create Partner Form',
        meta: { roles: DEALER, title: 'Partners' },
        component: () => import('@/forms/PartnerForm')
    },
    {
        path: '/teams/:mode',
        name: 'Create Team Form',
        meta: { roles: DEALER, title: 'Teams' },
        component: () => import('@/forms/TeamForm')
    },
    {
        path: '/users/:mode',
        name: 'Create User Form',
        meta: { title: 'Users' },
        component: () => import('@/forms/UserForm')
    },
    {
        path: '/transactions/:mode',
        name: 'Transactions Form',
        meta: { title: 'Transactions' },
        component: () => import('@/forms/TransactionForm')
    },
    {
        path: '/about-us',
        name: 'About Us',
        meta: { title: 'About Us' },
        component: () => import('@/routes/AboutUsRoute')
    },
    {
        path: '/statistics',
        name: 'Statistics',
        meta: { title: 'Statistics' },
        component: () => import('@/routes/StatsRoute')
    },
    {
        path: '/promos',
        name: 'Promos',
        meta: { title: 'Promo' },
        component: () => import('@/routes/PromoRoute')
    },
    {
        path: '/promos/:promoId/:mode',
        name: 'Edit Promo Form',
        meta: { title: 'Promo' },
        component: () => import('@/forms/PromoForm')
    },
    {
        path: '/promos/:mode',
        name: 'Create Promo Form',
        meta: { title: 'Promo' },
        component: () => import('@/forms/PromoForm')
    },
    {
        path: '*',
        redirect: '/'
    }
]

const router = new VueRouter({
    mode: 'history',
    routes
})

export function canAccess(route, user) {
    if (!user) {
        return false
    }
    if (user.role === 'admin') {
        return true
    }
    // dealers can only look: no create or edit pages
    if (route.params && route.params.mode && route.params.mode !== 'show') {
        return false
    }
    return ((route.meta && route.meta.roles) || []).includes(user.role)
}

router.beforeEach((to, from, next) => {
    const token = store.getters.getToken
    const loggedIn = !!token && !jwtUtil.isJwtExpired(token) && !!store.getters.currentUser

    if (to.meta.public) {
        return loggedIn ? next('/') : next()
    }
    if (!loggedIn) {
        const query = to.fullPath !== '/' ? { redirect: to.fullPath } : {}
        if (token) {
            // there was a session, it just ran out: say so on the login page
            store.dispatch('logout')
            query.expired = '1'
        }
        return next({ path: '/login', query })
    }
    if (canAccess(to, store.getters.currentUser)) {
        return next()
    }
    // Without this the navigation used to hang silently when a role was not allowed
    return next(from.name ? false : '/')
})

router.afterEach(to => {
    document.title = to.meta.title ? `${to.meta.title} · Paron Admin` : 'Paron Admin'
})

export default router
